import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

import { MembershipsRouter } from './membership/_router'
import { ProspectsRouter } from './prospects/_router'
import { ShareholdersRouter } from './shareholder/_router'

const Index = lazy(() => import('./Index'))

export const MembersRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--members']}>
    <Route index element={<Index />} />
    <Route path='membership/*' element={<MembershipsRouter />} />
    <Route path='shareholder/*' element={<ShareholdersRouter />} />
    <Route path='prospects/*' element={<ProspectsRouter />} />
  </SubRouter>
))
